<div class="policy bg-light">

    <div class="policy__container" [style.height.px]="appAlert.windowHeight - 200">
        <div class="policy_header">
            <h1>Polityka prywatności</h1>
        </div>

        <div class="policy_paragraph">
            <p class="policy_paragraph__content">
                Niniejsza polityka prywatności została przyjęta w związku z wejściem w życie rozporządzenia Parlamentu Europejskiego
                i Rady (UE) nr 2016/679 z dnia 27 kwietnia 2016 r.  w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych
                osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (Dziennik Urzędowy Unii
                Europejskiej nr L 119/1 z 4.5.2016; dalej: RODO). Celem polityki jest w szczególności wykonanie obowiązku informacyjnego,
                o którym mowa w art. 13 i 14 RODO.
            </p>
            <h1 id="definitions">1. Definicje</h1>
            <p class="policy_paragraph__content">
                W treści niniejszej polityki posługujemy się poniższymi zwrotami:
            </p>
            <ol class="pp_list">
                <li class="policy__list-item">My, <strong>TECH STEROWNIKI</strong>, administrator - <strong>TECH STEROWNIKI Spółka z ograniczoną odpowiedzialnością
                    Sp.k..</strong> z siedzibą w miejscowości Wieprz 34-122 przy ul. Biała Droga 31 wpisana do rejestru przedsiębiorców
                    KRS pod nr 0000594881, NIP: 5512360632, REGON: 356782780.
                </li>
                <li class="policy__list-item">Ty, Pan, Pani, Państwo – osoby, których dane osobowe są przetwarzane przez TECH STEROWNIKI.</li>
            </ol>
        </div>

        <div class="policy_paragraph">
            <h1>2. Kim jest administrator danych?</h1>
            <p class="policy_paragraph__content">
                Administrator danych to osoba ustalająca cele i sposoby przetwarzania danych osobowych. Administratorem Państwa
                danych osobowych jest <strong>TECH STEROWNIKI Spółka z ograniczoną odpowiedzialnością Sp.k.</strong>
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>3. Jakie dane osobowe przetwarzamy?</h1>
            <p class="policy_paragraph__content">
                W związku z prowadzoną działalnością, przetwarzamy w szczególności dane osobowe: naszych kontrahentów będących osobami
                fizycznymi (w tym: klientów, dostawców itd.), osób kontaktowych wskazanych przez wspomnianych kontrahentów (w tym:
                przedstawicieli handlowych, osób wskazanych jako odpowiedzialne za realizacje wspólnych projektów, kierowców itd.),
                osób z którymi prowadzimy korespondencje, osób uzyskujących możliwość wejścia na teren naszego zakładu, osób
                zainteresowanych zatrudnieniem, pracowników, a także osób pozostających z naszymi pracownikami w relacjach
                powodujących skutki prawne (w tym: dzieci, członków rodzin itd.). Zakres przetwarzanych danych każdorazowo jest
                adekwatny do celów przetwarzania.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>4. W jakich celach przetwarzamy dane?</h1>
            <p class="policy_paragraph__content">
                Państwa dane osobowe mogą być przetwarzane w następujących celach:
            </p>
            <ol type="1">
                <li class="policy__list-item">
                    wykonanie zawartych umów lub podjęcie działań celem zawarcia umowy na Państwa żądanie (w oparciu o
                    art. 6 ust. 1 lit. b RODO). W takim wypadku dane przetwarzane są przez okres obowiązywania umowy, a także dalszy
                    okres niezbędny do pełnej realizacji wynikających zeń praw i obowiązków.
                </li>
                <li class="policy__list-item">
                    wykonanie ciążących na nas obowiązków prawnych, w szczególności w zakresie prawa podatkowego, przepisów o
                    rachunkowości lub archiwizacji, przepisów o przeciwdziałaniu praniu brudnych pieniędzy przepisów, przepisów
                    regulujących system ubezpieczeń społecznych itd. (art. 6 ust. 1 lit. c RODO). Czas przetwarzania danych
                    determinowany jest wówczas przez przepisy stanowiące podstawę danego obowiązku.
                </li>
                <li class="policy__list-item">
                    <p>
                        Realizacji naszego prawnie uzasadnionego interesu (art. 6 ust. 1 lit. f RODO) – polegającego na:
                    </p>
                    <ol type="a">
                        <li class="policy__list-item">
                            prowadzeniu marketingu bezpośredniego naszych towarów lub usług
                        </li>
                        <li class="policy__list-item">
                            tworzeniu zestawień, analiz i statystyk – co obejmuje zwłaszcza
                            badania marketingowe, analizy danych handlowych, planowanie rozwoju usług itd.
                        </li>
                        <li class="policy__list-item">
                            ustalaniu, dochodzeniu lub obronie przed roszczeniami
                        </li>
                        <li class="policy__list-item">
                            prowadzeniu korespondencji za pomocą wszelkich znanych technologii, w tym: poczty tradycyjnej, poczty
                            elektronicznej (email) lub innych metod komunikacji (np. komunikatorów internetowych itd.).
                        </li>
                        <li class="policy__list-item">
                            nawiązywaniu kontaktu telefonicznego.
                        </li>
                        <li class="policy__list-item">
                            inicjowaniu i podtrzymywaniu kontaktów biznesowych.
                        </li>
                        <li class="policy__list-item">
                            prawidłowym wyświetlaniu naszych witryn internetowych,
                        </li>
                        <li class="policy__list-item">
                            prowadzeniu monitoringu wizyjnego naszego zakładu (zakładów) – w zakresie niezbędnym dla
                            zapewnienia bezpieczeństwa osób i mienia znajdujących się na jego (ich) terenie oraz zachowanie
                            w tajemnicy informacji, których ujawnienie mogłoby narazić nas na szkodę,
                        </li>
                    </ol>
                    <p>
                        W przypadkach wymienionych w pkt. 3 - dane przetwarzane będą przez czas utrzymywania się interesu
                        w związku z którym są przetwarzane. W szczególności: (i) działania marketingowe prowadzone będą
                        do czasu zgłoszenia przez Państwa stosownego sprzeciwu, zaś (ii) zapis z monitoringu wizyjnego
                        będzie przechowywany przez nie dłużej niż 3 miesiące, chyba że co innego wynika z powszechnie
                        obowiązujących przepisów.
                    </p>
                </li>
                <li class="policy__list-item">
                    niekiedy Państwa dane osobowe mogą być przetwarzane w innych celach, w oparciu o stosowną zgodę – wyrażoną w sposób
                    dobrowolny, konkretny, świadomy i jednoznaczny (art. 6 ust. 1 lit. a RODO). Zgoda stanowi w szczególności podstawę
                    przetwarzania niektórych danych gromadzonych na potrzeby postępowań rekrutacyjnych (zawartych w CV itd.).
                </li>
            </ol>
            <p>
                W takim wypadku: (i) dane przetwarzane będą przez okres adekwatny do celu wskazanego w treści zgody, (ii) macie
                Państwo prawo do cofnięcia zgody w dowolnym momencie, bez wpływu na zgodność z prawem przetwarzania którego
                dokonano na podstawie zgody przed jej cofnięciem.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>5. Czy podanie danych osobowych jest obowiązkowe?</h1>
            <p class="policy_paragraph__content">
                Nie macie Państwo obowiązku udostępniania nam swoich danych osobowych. Tym niemniej, odmowa może spowodować
                niemożliwość zawarcia lub wykonania zawartej z nami umowy lub realizacji przez nas innych czynności (np. przesłania
                korespondencji, uzyskania dostępu na teren zakładu, uczestnictwa w procesie rekrutacyjnym itd.).
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>6. Czy dane mogą być przetwarzane w procesach obejmujących zautomatyzowane podejmowanie decyzji, w tym
                profilowanie „kwalifikowane”?</h1>
            <p class="policy_paragraph__content">
                Obecnie nie stosujemy żadnych operacji, w ramach których dochodziłoby do zautomatyzowanego podejmowania  decyzji
                wywołujących po stronie ich adresatów skutki prawne lub w podobny sposób istotnie na nich wpływających. W przypadku
                wdrożenia w przyszłości takich operacji związanych z przetwarzaniem danych osobowych – zapewnimy ich zgodność ze
                właściwymi przepisami, w tym art. 22 RODO.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>7. Komu możemy udostępniać Państwa dane osobowe?</h1>
            <p class="policy_paragraph__content">
                Państwa dane osobowe mogą zostać udostępnione podmiotom trzecim wyłącznie w przypadku, gdy będziemy do tego zobowiązani
                lub uprawnieni na podstawie przepisów prawa. Odbiorami danych mogą być zwłaszcza:
            </p>
            <ol type="1">
                <li class="policy__list-item">
                    podmioty przetwarzające, w tym:
                    <ol type="a">
                        <li class="policy__list-item">
                            osoby obsługujące naszą infrastrukturę lub systemy informatyczne, a także dokonujące utylizacji
                            zbędnej dokumentacji lub nośników danych,
                        </li>
                        <li class="policy__list-item">
                            podwykonawcy uczestnicząc w realizacji zaciągniętych względem Państwa zobowiązań,
                        </li>
                        <li class="policy__list-item">
                            osoby świadczące usługi związane z wykonaniem lub ulepszeniem procesu sprzedaży (np. pośrednicy płatności,
                            kurierzy lub przewoźnicy, agencje reklamowe, rzeczoznawcy uczestniczący w procedurach reklamacji),
                        </li>
                        <li class="policy__list-item">
                            osoby świadczące na naszą rzecz usługi audytorskie lub doradcze – np. w zakresie pomocy prawnej,
                            podatkowej lub rachunkowej.
                        </li>
                    </ol>
                </li>
                <li class="policy__list-item">
                    inni administratorzy, w tym:
                    <ol type="a">
                        <li class="policy__list-item">
                            organy administracji publicznej uprawnione do żądania udostępnienia danych,
                        </li>
                        <li class="policy__list-item">
                            spółki powiązane z nami,
                        </li>
                        <li class="policy__list-item">
                            inne podmioty – w przypadkach, gdy charakter świadczeń realizowanych przezeń na naszą rzecz powoduje, że
                            wskazane podmioty samodzielnie określają cele i sposoby przetwarzania danych osobowych i w związku
                            z tym stają się administratorami danych osobowych. Może to dotyczyć zwłaszcza: agencji reklamowych,
                            agencji uczestniczących w organizacji konkursów lub wydarzeń promocyjnych, banków, kurierów
                            i przewoźników, a także podmiotów współpracujących z nami przy obsłudze spraw rachunkowych,
                            podatkowych lub prawnych,
                        </li>
                        <li class="policy__list-item">
                            nabywcy wierzytelności względem Państwa – w przypadku, gdy zdecydujemy się na dokonanie zbycia
                            takich wierzytelności, w szczególności z uwagi na istnienie znacznych zaległości płatniczych.
                        </li>
                    </ol>
                </li>
            </ol>
            <p>
                Nie ujawnimy Państwa danych osobowych osobom, które nie są uprawnione do ich przetwarzania.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>8. Czy Państwa dane osobowe mogą być przekazywane poza Europejski Obszar Gospodarczy (EOG)?</h1>
            <p class="policy_paragraph__content">
                Obecnie nie przewidujemy przekazywania Państwa danych poza Europejski Obszar Gospodarczy. Nie wykluczamy jednak,
                że w przyszłości możemy uznać to za zasadne. W takim wypadku, Państwa dane będą zabezpieczone w sposób wymagany
                przez powszechnie obowiązujące przepisy, w szczególności poprzez zastosowanie tzw. standardowych klauzul umownych (SCC).
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>9. Jakie prawa przysługują Państwu w związku z przetwarzaniem danych?</h1>
            <p class="policy_paragraph__content">
                Możecie Państwo wystąpić do nas w szczególności z wnioskiem o:
            </p>
            <ol type="1">
                <li class="policy__list-item">
                    dostęp do przetwarzanych przez nas danych (w tym: informację o przetwarzaniu przez nas danych lub
                    przekazanie kopii danych),
                </li>
                <li class="policy__list-item">
                    sprostowanie (poprawienie) danych,
                </li>
                <li class="policy__list-item">
                    ograniczenie przetwarzania (wstrzymanie operacji na danych lub nieusuwanie danych),
                </li>
                <li class="policy__list-item">
                    usunięcie danych (“prawo do bycia zapomnianym”),
                </li>
                <li class="policy__list-item">
                    przeniesienie danych do innego administratora.
                </li>
            </ol>
            <p>
                Powyższe wnioski mogą być wysyłane w szczególności w sposób określony w pkt. 13 poniżej – i będą rozpatrywane
                zgodnie z właściwymi przepisami, w tym art. 15-20 RODO.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>10. Prawo sprzeciwu</h1>
            <p class="policy_paragraph__content">
                Niezależnie od powyższego, jesteście Państwo uprawnieni do wniesienia sprzeciwu względem przetwarzania danych, które
                realizowane jest w oparciu o nasz prawnie uzasadniony interes. W takim wypadku:
            </p>
            <ol type="1">
                <li class="policy__list-item">
                    jeżeli dane osobowe są przetwarzane na cele marketingu – niezwłocznie zaprzestaniemy takiego przetwarzania.
                </li>
                <li class="policy__list-item">
                    jeżeli podstawą przetwarzania danych jest interes innego rodzaju – zaprzestaniemy takiego przetwarzania, chyba
                    że wykażemy: a) że wspomniany interes jest nadrzędny wobec Państwa interesów, praw i wolności lub też b) istnienie
                    podstawy do ustalenia, dochodzenia lub obrony roszczeń.
                </li>
            </ol>
            <p>
                Prawo sprzeciwu może być realizowane w szczególności poprzez wysyłkę stosownego oświadczenia w sposób określony
                w pkt. 13 poniżej.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>11. Skarga do organu nadzorczego</h1>
            <p class="policy_paragraph__content">
                W przypadku, gdy uznacie Państwo że przetwarzanie danych, które Państwa dotyczy, narusza obowiązujące przepisy - macie
                Państwo prawo wnieść skargę do organu nadzorczego, tj. Prezesa Urzędu Ochrony Danych Osobowych.
            </p>
        </div>

        <div class="policy_paragraph">
            <h1>12. Miejsce publikacji oraz aktualizacje polityki prywatności</h1>
            <p class="policy_paragraph__content">
                Niniejsza polityka prywatności może od czasu do czasu podlegać zmianom. Aktualna wersja polityki będzie każdorazowo
                dostępna przez cały czas na naszej stronie internetowej pod adresem:
                <a href="/docs/policies/polityka_prywatnosci_tech.pdf"
                   download="polityka_prywatnosci_tech.pdf" target="_self">
                   {{ appAlert.origin() + '/docs/policies/polityka_prywatnosci_tech.pdf' }}
                </a>
            </p>
        </div>

        <div class="policy_paragraph">
            <h1 id="">13. Jak można się z nami skontaktować?</h1>
            <p class="policy_paragraph__content">
                W razie jakichkolwiek pytań dotyczących sposobu wykorzystania przez nas Państwa danych osobowych, można się
                z nami skontaktować telefonicznie, pocztą elektroniczną lub listownie pod następującymi numerami i adresami:
            </p>
            <strong>TECH STEROWNIKI Spółka z ograniczoną odpowiedzialnością Sp.k.</strong><br />
            <p>
                Wieprz 34-122 przy ul. Biała Droga 31 przy - z dopiskiem: „ochrona danych osobowych”
                tel. +48 33 875 93 80; e-mail: serwis&#64;techsterowniki.pl
            </p>
        </div>

    </div>

    <div class="policy__buttons-box">
        <input type="button"
               [value]="subtitles.setSubtitle(1744)"
               class="app-alert__button  bg-ok color-light font-bold font-14 cursor-pointer"
               (click)="appAlert.closePolicy()">
    </div>

</div>

